import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useQuery } from "react-query";

export const useFetchVessels = () => {
  const { token } = useContext(AuthContext);

  const fetchVessels = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/vessel/myVessels`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(errorResponse.message || "Failed to fetch vessels");
    }

    return response.json();
  };

  return useQuery("vessels", fetchVessels, {
    onError: (error) => {
      console.error("Error fetching vessels:", error);
    },
  });
};
